import { useUnit } from 'effector-react';
import _ from 'lodash';
import { $modals } from 'models/store-modals';
import { useEffect } from 'react';

import ModalsService from 'services/ModalsService';

import { type RegisteredModals } from 'types/Modals';

type Options = {
    onOpen?: (state: any) => void;
    onClose?: () => void;
};

const useModal = (name: RegisteredModals, options?: Options) => {
    const { onOpen = () => {}, onClose = () => {} } = options || {};

    const modal = useUnit(
        $modals.map((state) => ({
            ..._.get(state, name),
            suppressed: ModalsService.isSuppressed(name),
            isOpened: state[name]?.isOpened === true,
        })),
    );
    modal.suppressed = ModalsService.isSuppressed(name);
    const { isOpened = false, preventClosing = false, state = {} } = modal;

    useEffect(() => {
        if (isOpened) {
            if (onOpen) {
                onOpen(state);
            }
        } else {
            if (onClose) {
                onClose();
            }
        }
    }, [isOpened]);

    const handlers = {
        open: () => ModalsService.showModal(name),
        close: () => {
            if (preventClosing !== true) {
                ModalsService.hideModal(name);
            }
        },
    };

    return { name, ...modal, ...handlers };
};

export default useModal;
